// The instance page's tabs, deep-linked via ?tab=. `windowed` marks tabs whose
// panels all follow the time range, so the picker only shows where it applies.

export type InstanceTab = "overview" | "health" | "usage" | "integrations" | "billing" | "activity" | "settings";

type TabDef = { readonly value: InstanceTab; readonly label: string; readonly windowed: boolean };

export const INSTANCE_TABS: ReadonlyArray<TabDef> = [
  { value: "overview", label: "Overview", windowed: true },
  { value: "health", label: "Health", windowed: true },
  { value: "usage", label: "Usage", windowed: true },
  { value: "integrations", label: "Integrations", windowed: false },
  { value: "billing", label: "Billing", windowed: false },
  { value: "activity", label: "Activity", windowed: true },
  { value: "settings", label: "Settings", windowed: false },
];

export const visibleTabs = (billingEnabled: boolean): ReadonlyArray<TabDef> =>
  billingEnabled ? INSTANCE_TABS : INSTANCE_TABS.filter((t) => t.value !== "billing");

export const parseTab = (raw: string | null, billingEnabled: boolean): InstanceTab =>
  visibleTabs(billingEnabled).find((t) => t.value === raw)?.value ?? "overview";

export const tabIsWindowed = (tab: InstanceTab): boolean =>
  INSTANCE_TABS.find((t) => t.value === tab)?.windowed ?? false;
